<!-- LIVE -->
<app-player-evidenza></app-player-evidenza>
<!-- LIVE -->

<div class="px-8 lg:px-16 xl:px-container">

  <!-- CANALI IN EVIDENZA -->
  <!-- <div class="canali-evidenza" *ngIf="canali_evidenza.length > 0 && !loading" [@fadeInOut]>    
    <h3 class="z-10 relative my-8 font-bold text-white text-3xl lg:text-5xl">Canali in primo piano</h3>              
    <app-galleria-canali [canali]="canali_evidenza" [evidenza]="true" class="relative"></app-galleria-canali>          
  </div> -->
  <!-- CANALI IN EVIDENZA -->

  <!-- TUTTI I CANALI -->
  <div class="canali" *ngIf="!loading" [@fadeInOut]>
    <h3 class="z-10 relative my-8 lg:mt-16 font-bold text-white text-2xl md:text-3xl lg:text-4xl">I nostri canali</h3>
    <h3 class="flex justify-center items-center my-8 text-white text-xl lg:text-2xl" *ngIf="canali.length <= 0">Nessun canale caricato</h3>
    <app-galleria-canali [canali]="canali" class="relative" *ngIf="canali.length > 0"></app-galleria-canali>
  </div>
  <!-- TUTTI I CANALI -->

  <!-- CATEGORIE ON DEMAND -->
  <div class="categorie-ondemand" *ngIf="!loading" [@fadeInOut]>
    <div class="ondemands" *ngFor="let ondemand of ondemands">
      <ng-container *ngIf="ondemand.video.length > 0">
        <h3 class="my-8 lg:mt-16 font-bold text-white text-2xl md:text-3xl lg:text-4xl">{{ondemand.categoria == 'Generale' ? 'Guarda anche' : ondemand.categoria }}</h3>
        <app-galleria-video [ondemands_home]="ondemand"></app-galleria-video>
      </ng-container>
    </div>
  </div>
</div>
<!-- CATEGORIE ON DEMAND -->

<!-- RADIO PARTNER -->
<div class="px-8 lg:px-16 xl:px-container" *ngIf="!loading" [@fadeInOut]>
  <h3 class="my-8 lg:mt-16 font-bold text-white text-2xl md:text-3xl lg:text-4xl">Radio Partner</h3>
  
  <div class="flex lg:flex-row flex-col items-center lg:items-start gap-8 mb-8">
    <!-- Descrizione -->
    <div class="flex flex-col gap-4 w-full lg:w-1/2">
      <p class="text-white text-base lg:text-lg leading-relaxed">
        Ascolta <strong>Radio Compilation</strong>, la radio ufficiale partner di Seven Live Web TV.
      </p>
      <p class="text-white/80 text-sm lg:text-base leading-relaxed">
        Musica, notizie e intrattenimento 24 ore su 24. Unisciti a noi e scopri la migliore selezione musicale in diretta streaming.
      </p>
      <div class="flex flex-wrap gap-3 mt-2">
        <span class="bg-white/10 px-3 py-1 rounded-full text-white text-xs lg:text-sm">🎵 Live 24/7</span>
        <span class="bg-white/10 px-3 py-1 rounded-full text-white text-xs lg:text-sm">🎧 Alta Qualità</span>
        <span class="bg-white/10 px-3 py-1 rounded-full text-white text-xs lg:text-sm">📻 Streaming</span>
      </div>
    </div>
    
    <!-- Player -->
    <div class="flex justify-center lg:justify-end w-full lg:w-1/2">
      <app-radio-player></app-radio-player>
    </div>
  </div>
</div>
<!-- RADIO PARTNER -->

<!-- BANNER INFO -->
<div class="relative flex lg:flex-row flex-col justify-center gap-4 my-8 lg:my-16 px-8 lg:px-16 xl:px-container lg:pe-0 info" *ngIf="!loading" [@fadeInOut]>
  <div class="flex flex-col gap-4 lg:my-auto py-8 w-full lg:w-1/2">
    <h2 class="font-bold text-white text-2xl md:text-3xl">Guarda tutto ciò che desideri, <br> quando lo vuoi tu</h2>
    <ng-container *ngIf="abbonamento">
      <p class="text-sm lg:text-xl">Visita l'area On Demand per guardare tutti i nostri video disponibili!</p>
      <button class="mt-4 lg:w-fit bottone" nzType="primary" nz-button [routerLink]="'/ondemand'">ON DEMAND</button>
    </ng-container>
    <ng-container *ngIf="!abbonamento">
      <p class="text-sm lg:text-xl">Abbonati ora a Seven Live Web TV premendo il pulsante sottostante o accedendo alla tua area personale!</p>
      <button class="mt-4 lg:w-fit bottone" nzType="primary" nz-button [routerLink]="user?.id ? '/profilo/abbonamento' : '/login'">ABBONATI</button>
    </ng-container>
    <div class="flex flex-row items-center gap-4 lg:my-4">
      <a href="https://play.google.com/store/apps/details?id=com.sevenlive.app" target="_blank">
        <img class="block w-36 lg:w-52 h-auto lg:h-16" src="../../../assets/images/GetItOnGooglePlay_Badge_Web_color_Italian.png" alt="Scarica l'app Android">
      </a>
      <a href="https://apps.apple.com/us/app/7live-tv/id6667118264" target="_blank">
        <img class="block w-36 lg:w-52 h-auto lg:h-16" src="../../../assets/images/Download_on_the_App_Store_Badge_IT_RGB_blk_100317.svg" alt="Scarica l'app iOS">
      </a>
    </div>
  </div>
  <div class="relative bg-cover lg:bg-contain bg-no-repeat lg:bg-right w-full lg:w-1/2 h-1/2 lg:h-full sfondo"> </div>
</div>
<!-- BANNER INFO -->

<!-- NEWS -->
<div class="px-8 lg:px-16 xl:px-container" *ngIf="notizie.length > 0 && !loading" [@fadeInOut]>
  <h3 class="block my-8 lg:mt-16 font-bold text-white text-2xl md:text-3xl lg:text-4xl">News</h3>
  <app-notizia *ngFor="let notizia of notizie.slice(0,5); let i = index" [notizia]="notizia" [notizie]="notizie.slice(0,5)" [index]="i"></app-notizia>
</div>
<!-- NEWS -->